import type { RouteRecordRaw } from 'vue-router'

const SetupItemsPage = () => import('./pages/SetupItemsPage.vue')
const SetupLocationsPage = () => import('./pages/SetupLocationsPage.vue')
const SetupUnitsPage = () => import('./pages/SetupUnitsPage.vue')

// Inventory routes that live under the existing /setup section.
const inventorySetupRoutes: RouteRecordRaw[] = [
  {
    name: 'items',
    path: 'items',
    component: SetupItemsPage,
    meta: { requiresAuth: true },
  },
  {
    name: 'units',
    path: 'units',
    component: SetupUnitsPage,
    meta: { requiresAuth: true },
  },
  {
    name: 'locations',
    path: 'locations',
    component: SetupLocationsPage,
    meta: { requiresAuth: true },
  },
]

export default inventorySetupRoutes
